import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import { createOrder } from 'services/api'
import {
  addAccessTokenToSession,
  addOrderIdToSession,
} from 'utils/sessionHelper'
import {
  getColoring,
  getCustomData,
  getPipelineId,
  isGlobalContextOrderValid,
} from 'utils/orderHelper'

import { useStateManager } from 'components/context/StateManager'

function useCreateOrder(): {
  isLoading: boolean
} {
  const router = useRouter()
  const [state, setState] = useStateManager()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Only create order when router is ready
    if (!router.isReady) return

    if (isGlobalContextOrderValid(state.order)) {
      setIsLoading(false)

      return
    }

    const initiateOrder = async () => {
      const coloring = getColoring(router)
      const customData = getCustomData(router)
      const response = await createOrder(
        getPipelineId(router),
        coloring,
        customData
      )

      if (!response) {
        setIsLoading(false)

        return
      }

      const { id, access_token } = response

      addOrderIdToSession(id)
      addAccessTokenToSession(access_token)
      setState({
        ...state,
        accessToken: access_token,
        order: {
          ...state.order,
          orderId: id,
        },
        coloring,
        customData,
      })
      setIsLoading(false)
    }

    initiateOrder()
  }, [router, state, setState])

  return { isLoading }
}

export default useCreateOrder
